import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Collapse from '@mui/material/Collapse';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Button from 'components/Button';
import Card from 'components/Card';
import Label from 'components/Label';
import Snackbar from 'components/Snackbar';
import moment from 'moment';
import api from 'services/api';
import { validatePermission } from 'actions/index';
import { formatDateTime } from 'utils/formatter';
import TabsDetalhesFinanceiro from './TabsDetalhesFinanceiro';
import { ContentInvoice, InvoiceRow, InvoiceActionsRow } from './styles';
import { number_format } from '../../functions';

export default function CardFinanceiro(financial) {
  const readableTextColor = '#627182';

  const [expanded, setExpanded] = React.useState(false);

  const [faturasList, setFaturasList] = useState([]);
  const [boletosList, setBoletosList] = useState([]);
  const [cteList, setCteList] = useState([]);
  const [ediList, setEdiList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [snackBar, setSnackBar] = useState({
    display: false,
    type: 'error',
    message: '',
  });

  const navigate = useNavigate();

  function handleExpandClick() {
    setExpanded(!expanded);
    getFaturas(financial);
    getBoletos(financial);
    getCTe(financial);
    getEdi(financial);
  }

  async function getFaturas(financial) {
    const cteNf = financial.financial.nfs
      ? financial.financial.nfs
      : financial.financial.cte_number === null
      ? ''
      : financial.financial.cte_number[0].trim();
    const responseFaturas = await api.get(
      `invoice-billing-travel/${financial.financial.attended_id}/${cteNf}`,
    );

    if (responseFaturas.status === 200) {
      setFaturasList(responseFaturas.data);
    }
  }

  async function getEdi(financial) {
    const responseEdi = await api.get(`edi-billing-travel/${financial.financial.attended_id}`);

    if (responseEdi.status === 200) {
      setEdiList(responseEdi.data);
    }
  }

  async function getBoletos(financial) {
    const responseBoletos = await api.get(
      `billet-billing-travel/${financial.financial.attended_id}?cte_number=${
        financial.financial.nfs || financial.financial.cte_number
      }`,
    );

    if (responseBoletos.status === 200) {
      setBoletosList(responseBoletos.data);
    }
  }

  async function getCTe(financial) {
    const responseCTE = await api.get(`cte-travel-data/${financial.financial.id}`);

    if (responseCTE.status === 200) {
      setCteList(responseCTE.data);
    }
  }

  function pickBorderColor(financial) {
    const status = financial.financial.status.toLowerCase();
    if (status === undefined) return '';
    switch (status) {
      case 'pago no prazo':
        return 'success';
      case 'cobrando':
        return 'danger';
      case 'pago em atraso':
        return 'warning';
      case 'cancelada':
        return 'secondary_light';
      default:
        return '';
    }
  }

  function editInvoice(invoiceNfs) {
    navigate(`/faturas/${invoiceNfs}`);
  }

  async function approve() {
    try {
      const res = await api.put(`billing-travel-data/${financial.financial.id}`, {
        approved_at: new Date(),
      });

      setSnackBar({
        type: 'success',
        message: 'Fatura aprovada com sucesso.',
        display: true,
      });

      financial.updateFinancial(res.data);
    } catch (ex) {
      setSnackBar({
        type: 'error',
        message: 'Não foi possível aprovar essa fatura.',
        display: true,
      });
    }
  }

  return (
    <Grid container style={{ width: '100%' }}>
      <Snackbar
        open={snackBar.display}
        type={snackBar.type}
        message={snackBar.message}
        onClose={() => setSnackBar(false)}
      />
      <Grid item xs={12} style={{ width: '100%' }}>
        <Card
          bordered
          bordercolor={pickBorderColor(financial)}
          style={{ marginBottom: '15px', width: '100%' }}
        >
            <Grid container>
              <InvoiceRow>
                <ContentInvoice
                  item
                  xs={12}
                  md={8}
                  style={{ flex: '1 1 0', maxWidth: '100%' }}
                >
                  <ul>
                    <li>
                      <label>
                        <strong>{financial.financial.social_name}</strong> -{financial.financial.cgccpf}
                      </label>
                    </li>
                    <li>
                      <label>FATURA:</label>
                      {financial.financial.numero_fatura && financial.financial.numero_fatura === null
                        ? 'Não cadastrada'
                        : financial.financial.numero_fatura}
                    </li>
                    <li>
                      <label espaco={1}>NF:</label>
                      {financial.financial.numero_nota === null
                        ? 'Não cadastrada'
                        : financial.financial.numero_nota.trim()}
                    </li>
                    <li>
                      <label espaco={1}>CTe/NFS:</label>
                      {financial.financial.nfs
                        ? financial.financial.nfs
                        : financial.financial.cte_number === null
                        ? 'Não cadastrada'
                        : Array.isArray(financial.financial.cte_number)
                        ? financial.financial.cte_number.join(', ')
                        : financial.financial.cte_number.trim()}
                    </li>
                    <li />
                  </ul>
                </ContentInvoice>
                <ContentInvoice
                  item
                  xs={12}
                  md={4}
                  right
                  style={{ flex: '0 0 320px', maxWidth: '320px' }}
                >
                  <ul>
                    <li>
                      {validatePermission('APROVAR_FATURA') ? (
                        <>
                          {!loading && (
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                              {financial.financial.approved_at === null ? (
                                <Button
                                  style={{
                                    width: '165px',
                                    display: 'inline-block',
                                    marginLeft: 'auto',
                                  }}
                                  color="success"
                                  onClick={approve}
                                  disabled={financial.financial.approved_at}
                                >
                                  Aprovar
                                </Button>
                              ) : (
                                <Label
                                  style={{
                                    width: 'auto',
                                    maxWidth: '100%',
                                    display: 'inline-block',
                                    marginLeft: 'auto',
                                    whiteSpace: 'normal',
                                    textAlign: 'right',
                                    color: readableTextColor,
                                  }}
                                >
                                  Aprovada em {formatDateTime(financial.financial.approved_at)}
                                </Label>
                              )}
                            </div>
                          )}
                        </>
                      ) : (
                        financial.financial.approved_at && (
                          <>
                            {!loading && (
                              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                {financial.financial.approved_at && (
                                <Label
                                  style={{
                                    whiteSpace: 'normal',
                                    textAlign: 'right',
                                    color: readableTextColor,
                                  }}
                                >
                                  Aprovada em {formatDateTime(financial.financial.approved_at)}
                                </Label>
                                )}
                              </div>
                            )}
                          </>
                        )
                      )}
                    </li>
                    <li>
                      <label>STATUS:</label>
                      {financial.financial.status === null
                        ? 'Não informado'
                        : `${financial.financial.status}`}
                    </li>
                    <li>
                      <label>VALOR:</label>
                      {financial.invoice_amount === null
                        ? 'Não possui valor cadastrado'
                        : `R$ ${number_format(financial.financial.valor_nota, 2, ',', '.')}`}
                    </li>
                    <li>
                      <label>VENCIMENTO:</label>
                      {financial.financial.vencimento
                        ? moment(financial.financial.vencimento).format('DD/MM/YYYY')
                        : ''}
                    </li>
                    <li />
                  </ul>
                </ContentInvoice>
              </InvoiceRow>
              <InvoiceActionsRow>
                {(validatePermission('APROVAR_FATURA') ||
                  validatePermission('EDITAR_FATURA') ||
                  validatePermission('ADICIONAR_COMENTARIO_FATURA')) && (
                  <Link
                    style={{
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                      cursor: 'pointer',
                      pointerEvents:
                        validatePermission('APROVAR_FATURA') ||
                        validatePermission('EDITAR_FATURA') ||
                        validatePermission('ADICIONAR_COMENTARIO_FATURA')
                          ? 'auto'
                          : 'none',
                    }}
                    onClick={() => editInvoice(financial.financial.id)}
                  >
                    Ver / Editar
                  </Link>
                )}
                <Button
                  variant="contained"
                  onClick={() => handleExpandClick()}
                  aria-expanded={expanded}
                >
                  {!expanded ? 'Mais detalhes' : 'Menos Detalhes'}
                </Button>
              </InvoiceActionsRow>
            </Grid>
        </Card>
        <div
          hidden={!expanded}
          style={{
            position: 'relative',
            marginBottom: '30px',
            backgroundColor: '#FFF',
            '@media (min-width: 768px)': {
              padding: '15px',
            },
            '@media (max-width: 768px)': {
              padding: '0',
            },
          }}
        >
          <Collapse in={expanded} timeout="auto" unmountOnExit />
          <TabsDetalhesFinanceiro
            style={{
              position: 'relative',
              '@media (min-width: 768px)': {
                padding: '15px',
              },
              '@media (max-width: 768px)': {
                padding: '0',
              },
            }}
            faturasList={faturasList}
            boletosList={boletosList}
            cteList={cteList}
            ediList={ediList}
            cteNumber={
              financial.financial.nfs
                ? financial.financial.nfs
                : financial.financial.cte_number === null
                ? '0'
                : Array.isArray(financial.financial.cte_number)
                ? financial.financial.cte_number.join(', ')
                : financial.financial.cte_number.trim()
            }
            attendedId={financial.financial.attended_id}
            handleClose={handleExpandClick}
          />
        </div>
      </Grid>
    </Grid>
  );
}
